'use client';

import * as React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';

import {cn} from '@/lib/utils';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50',
      // Unchecked state: muted background with border
      'data-[state=unchecked]:bg-muted data-[state=unchecked]:border-border',
      // Checked state: primary color (same green as buttons)
      'data-[state=checked]:bg-primary data-[state=checked]:border-primary',
      // Hover states
      'hover:data-[state=unchecked]:bg-muted/80 hover:data-[state=checked]:bg-primary/90',
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block h-5 w-5 rounded-full shadow-lg ring-0 transition-transform duration-200',
        // Thumb is always white for maximum contrast
        'bg-white',
        // Position
        'data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
